package com.kinoshazam.uiKit.components.textField

import androidx.compose.runtime.Stable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.VisualTransformation
import com.kinoshazam.uiKit.components.image.ImageUiKitState
import com.kinoshazam.uiKit.components.textField.filter.InputFilter
import com.kinoshazam.uiKit.components.textLabel.TextLabelState
import com.kinoshazam.uiKit.theme.UiKitTheme
import kotlin.jvm.JvmInline

data class TextFieldState(
    val label: TextLabelState? = null,
    val hint: TextLabelState? = null,
    val textValue: String? = null,
    val placeholder: TextLabelState? = null,
    val rightIcon: ImageUiKitState? = null,
    val leftIcon: ImageUiKitState? = null,
    val isSingleLine: Boolean = false,
    val minLines: Int = 1,
    val maxLines: Int = Int.MAX_VALUE,
    val maxLength: Int? = null,
    val showError: Boolean = false,
    val fieldType: FieldType = FieldType.Normal,
    val inputType: KeyboardType = KeyboardType.Text,
    val imeAction: ImeAction = ImeAction.Unspecified,
    val hasClearButton: Boolean = false,
    val hasProgress: Boolean = false,
    val isEnabled: Boolean = true,
    val isClickable: Boolean = false,
    val visualTransformation: VisualTransformation = VisualTransformation.None,
    val inputFilter: InputFilter = InputFilter.None,
    val id: String? = null,
    val payload: Any? = null,
    val containerColor: Color? = null,
//    val defaults: TextFieldDefaults = TextFieldDefaults()
) {

    @JvmInline
    value class FieldType private constructor(val value: Int) {

        companion object {

            @Stable
            val Outlined: FieldType = FieldType(1)

            @Stable
            val Normal: FieldType = FieldType(2)
        }
    }

//    data class TextFieldDefaults(
//        val cursorColor: Color = UiKitTheme.colors.color_6
//    )
}
